import { STATUS_LABELS } from '../AssignmentDetailDrawer/Constants'

import type { TaskAction } from './taskStatus'

export interface StatusConfirmation {
    question: string
    /** Пояснення під питанням — коли питання не називає новий статус */
    hint: string | null
    fromLabel: string
    toLabel: string
}

const label = (status: string): string => STATUS_LABELS[status] ?? status

/**
 * Текст вікна підтвердження зміни статусу водієм. Завершення завдання підтверджується
 * в поп-апі оцінок (CompleteTaskModal), тож сюди не потрапляє.
 */
export const statusConfirmation = (action: TaskAction, currentStatus: string): StatusConfirmation => {
    const toLabel = label(action.next)
    return {
        question: action.confirmQuestion ?? `Ви дійсно бажаєте змінити статус завдання на «${toLabel}»?`,
        hint: action.confirmQuestion ? `Статус завдання зміниться на «${toLabel}».` : null,
        fromLabel: label(currentStatus),
        toLabel,
    }
}
